<button (click)="onClick()" [class]="'btn btn-link text-neutral-800 f-small ' +  cssClasses">
    <ui-streamline-icon [slIcon]="{name: 'interface-arrows-button-left', theme: 'micro-bold', size: 'sm', svgStyle: {'padding-bottom': '2px'}}"></ui-streamline-icon>
    {{ text }}
</button>

